<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>

    <mat-dialog-content>
      <mat-tab-group [(selectedIndex)]="selectedTabIndex">
        <mat-tab label="Rate Season">

          <div [formGroup]="form1" *ngIf="form1">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="row">
                    <div class="col-lg-12">
                      @if (formAlert) {
                        <div class="w-100" style="padding:10px;">
                          <div class="w-100" style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                            <p><b>{{formAlert}}</b></p>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="col-lg-12">
                      <div class="w-100">
                        <h3>Overview</h3>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                      <mat-form-field class="w-100">
                        <mat-label>Rate Bucket</mat-label>
                        <mat-select [(value)]="form1.value.rateBucketId" formControlName="rateBucketId" required
                          pTooltip="Rate bucket this rate belongs.  Do not change unless you know what you are doing.">
                          @for (stat of rateBuckets; track stat) {
                            <mat-option [value]="stat.rateBucketId"> {{stat.name}}
                            </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.rateBucketId; track validation) {
                          <mat-error>
                            @if (form1.get('rateBucketId').hasError(validation.type) && (form1.get('rateBucketId').dirty || form1.get('rateBucketId').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-lg-12">
                      <mat-form-field class="w-100">
                        <mat-label>Season Name</mat-label>
                        <input matInput formControlName="name" readonly="{{formReadOnly}}" required pTooltip="Public viewable">
                        @for (validation of validationMessages.name; track validation) {
                          <mat-error>
                            @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                              <mat-error class="error-message">
                                {{validation.message}}
                              </mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6">
                      <mat-form-field class="w-100">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="startDatePicker" placeholder="Follow-Up Date" formControlName="startDate" required
                          pTooltip="Start of season - must NOT overlap with previous season's end date.">
                          <mat-datepicker-toggle [for]="startDatePicker"></mat-datepicker-toggle>
                          <mat-datepicker #startDatePicker disabled="false"></mat-datepicker>
                          @for (validation of validationMessages.startDate; track validation) {
                            <mat-error>
                              @if (form1.get('startDate').hasError(validation.type) && (form1.get('startDate').dirty || form1.get('startDate').touched)) {
                                <mat-error class="error-message">
                                {{validation.message}}</mat-error>
                              }
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <mat-form-field class="w-100">
                          <mat-label>End Date</mat-label> <input matInput [matDatepicker]="endDatePicker" placeholder="Follow-Up Date" formControlName="endDate" required
                          pTooltip="End of season - must NOT overlap with next season's start date.">
                          <mat-datepicker-toggle [for]="endDatePicker"></mat-datepicker-toggle>
                          <mat-datepicker #endDatePicker disabled="false"></mat-datepicker>
                          @for (validation of validationMessages.endDate; track validation) {
                            <mat-error>
                              @if (form1.get('endDate').hasError(validation.type) && (form1.get('endDate').dirty || form1.get('endDate').touched)) {
                                <mat-error class="error-message">
                                {{validation.message}}</mat-error>
                              }
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <mat-form-field class="w-100">
                          <mat-label>Rack Rate</mat-label>
                          <input matInput formControlName="listPriceAMT" readonly="{{formReadOnly}}" required pTooltip="Initial Rack Rate offered.">
                          @for (validation of validationMessages.listPriceAMT; track validation) {
                            <mat-error>
                              @if (form1.get('listPriceAMT').hasError(validation.type) && (form1.get('listPriceAMT').dirty || form1.get('listPriceAMT').touched)) {
                                <mat-error class="error-message">
                                  {{validation.message}}
                                </mat-error>
                              }
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <mat-form-field class="w-100">
                          <mat-label>List Price Adjust AMT</mat-label>
                          <input matInput formControlName="listPriceAdjustAMT" pTooltip="Rack Rate adjustment amount.">
                          @for (validation of validationMessages.listPriceAdjustAMT; track validation) {
                            <mat-error>
                              @if (form1.get('listPriceAdjustAMT').hasError(validation.type) && (form1.get('listPriceAdjustAMT').dirty || form1.get('listPriceAdjustAMT').touched)) {
                                <mat-error class="error-message"
                                  >
                                  {{validation.message}}
                                </mat-error>
                              }
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <div class="w-100">
                          <mat-label>List Price Adjust PCT: <b>{{listPriceAdjustPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('listPriceAdjustPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: -100 to 100 as decimal." tooltipPosition="bottom">
                              <input matSliderThumb #listPriceAdjustPCT formControlName="listPriceAdjustPCT">
                            </mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('listPriceAdjustPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <div class="w-100">
                          <mat-label>Monday Adjust PCT: <b>{{mondayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('mondayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: -100 to 100 as decimal." tooltipPosition="bottom">
                              <input matSliderThumb #mondayAdjPCT formControlName="mondayAdjPCT">
                            </mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('mondayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <div class="w-100">
                          <mat-label>Tuesday Adjust PCT: <b>{{tuesdayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('tuesdayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: -100 to 100 as decimal." tooltipPosition="bottom">
                              <input matSliderThumb #tuesdayAdjPCT formControlName="tuesdayAdjPCT">
                            </mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('tuesdayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <div class="w-100">
                          <mat-label>Wednesday Adjust PCT: <b>{{wednesdayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('wednesdayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: -100 to 100 as decimal." tooltipPosition="bottom">
                              <input matSliderThumb #wednesdayAdjPCT formControlName="wednesdayAdjPCT">
                            </mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('wednesdayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <div class="w-100">
                          <mat-label>Thursday Adjust PCT: <b>{{thursdayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('thursdayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: -100 to 100 as decimal." tooltipPosition="bottom">
                              <input matSliderThumb #thursdayAdjPCT formControlName="thursdayAdjPCT">
                            </mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('thursdayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <div class="w-100">
                          <mat-label>Friday Adjust PCT: <b>{{fridayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('fridayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: -100 to 100 as decimal." tooltipPosition="bottom">
                              <input matSliderThumb #fridayAdjPCT formControlName="fridayAdjPCT">
                            </mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('fridayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <div class="w-100">
                          <mat-label>Saturday Adjust PCT: <b>{{saturdayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('saturdayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: -100 to 100 as decimal." tooltipPosition="bottom">
                              <input matSliderThumb #saturdayAdjPCT formControlName="saturdayAdjPCT">
                            </mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('saturdayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <div class="w-100">
                          <mat-label>Sunday Adjust PCT: <b>{{sundayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('sundayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: -100 to 100 as decimal." tooltipPosition="bottom">
                              <input matSliderThumb #sundayAdjPCT formControlName="sundayAdjPCT">
                            </mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('sundayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <div class="row wrap">
                      <div class="col-lg-12">
                        <div class="w-100">
                          <h3>Settings</h3>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="w-100">
                          <mat-label>Min Nights Expected: <b>{{minStayExpectedNTS.value}} nights</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('minStayExpectedNTS', 0.25)">
                              <i class="pi pi-minus"></i>
                            </button>
												<mat-slider class="flex-1" min="0" max="30" step=".25" pTooltip="Range: 0 to 365 as integer. Documents least number of nights of an acceptable booking. Bookings made for less nights will
										be assessd a penalty (see Mark-Ups below)" tooltipPosition="bottom">
                              <input matSliderThumb #minStayExpectedNTS formControlName="minStayExpectedNTS">
                            </mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('minStayExpectedNTS', 0.25)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="w-100">
                          <mat-label>Max Nights Expected: <b>{{maxStayExpectedNTS.value}} nights</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('maxStayExpectedNTS', 0.25)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="0" max="30" step=".25"
                              pTooltip="Range: 0 to 365 as integer. Documents number of nights of good solid bookings." tooltipPosition="bottom">
                              <input matSliderThumb #maxStayExpectedNTS formControlName="maxStayExpectedNTS">
                            </mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('maxStayExpectedNTS', 0.25)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="w-100">
                          <mat-label>Avg Nights Expected: <b>{{avgStayBySeasonNTS.value}} nights</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('avgStayBySeasonNTS', 0.25)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="0" max="30" step=".25"
                              pTooltip="Range: 0 to 365 as integer. Documents number of nights of a reasonable booking." tooltipPosition="bottom">
                              <input matSliderThumb #avgStayBySeasonNTS formControlName="avgStayBySeasonNTS">
                            </mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('avgStayBySeasonNTS', 0.25)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <mat-form-field class="w-100">
                          <mat-label>Min Nightly Rate $ (Manager)</mat-label>
                          <input matInput formControlName="floorRateManagerAMT" readonly="{{formReadOnly}}"
                            pTooltip="Range: 0 to Infinity as currency.  Determines the lowest nightly rate offered even if discounting algorithms would offer a lower price, set by Manager.  Will be overridden by Min Nightly Rate $ set by Owner if exists.">
                            @for (validation of validationMessages.floorRateManagerAMT; track validation) {
                              <mat-error>
                                @if (form1.get('floorRateManagerAMT').hasError(validation.type) && (form1.get('floorRateManagerAMT').dirty || form1.get('floorRateManagerAMT').touched)) {
                                  <mat-error class="error-message"
                                    >
                                    {{validation.message}}
                                  </mat-error>
                                }
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6">
                          <mat-form-field class="w-100">
                            <mat-label>Min Nightly Rate $ (Owner)</mat-label>
                            <input matInput formControlName="floorRateOwnerAMT" readonly="{{formReadOnly}}"
                              pTooltip="Range: 0 to Infinity as currency.  Determines the lowest nightly rate offered even if discounting algorithms would offer a lower price, set by Owner.  Overrides Min Nightly Rate $ set by Manager.">
                              @for (validation of validationMessages.floorRateOwnerAMT; track validation) {
                                <mat-error>
                                  @if (form1.get('floorRateOwnerAMT').hasError(validation.type) && (form1.get('floorRateOwnerAMT').dirty || form1.get('floorRateOwnerAMT').touched)) {
                                    <mat-error class="error-message"
                                      >
                                      {{validation.message}}
                                    </mat-error>
                                  }
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100">
                              <mat-label>Season Demand</mat-label>
                              <mat-select [(value)]="form1.value.category" formControlName="category" required pTooltip="Range: Low to High (1-5). Documents perceived demand for accomodations.">
                                @for (stat of seasonCategories; track stat) {
                                  <mat-option [value]="stat.value"> {{stat.name}}
                                  </mat-option>
                                }
                              </mat-select>
                              @for (validation of validationMessages.category; track validation) {
                                <mat-error>
                                  @if (form1.get('category').hasError(validation.type) && (form1.get('category').dirty || form1.get('category').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Season Occupancy : <b>{{expectedOccupancyPCT.value*100}}%</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('expectedOccupancyPCT', 0.01)">
                                  <i class="pi pi-minus"></i>
                                </button>
                                <mat-slider class="flex-1" min="-1" max="1" step=".01"
                                  pTooltip="Range: 0 to 100 as decimal.  Estimates the occupancy for each season for calculations to the rack rate" tooltipPosition="bottom">
                                  <input matSliderThumb #expectedOccupancyPCT formControlName="expectedOccupancyPCT">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('expectedOccupancyPCT', 0.01)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100">
                              <mat-label>Rate Bucket Type</mat-label>
                              <mat-select [(value)]="form1.value.type" formControlName="type" required
                                pTooltip="Auto: Rack Rate adjusted by system or by bulk updates.  Manual:  Rate static, will not change by system or bulk updates.">
                                @for (stat of rateBucketTypes; track stat) {
                                  <mat-option [value]="stat.value"> {{stat.name}}
                                  </mat-option>
                                }
                              </mat-select>
                              @for (validation of validationMessages.type; track validation) {
                                <mat-error>
                                  @if (form1.get('type').hasError(validation.type) && (form1.get('type').dirty || form1.get('type').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row wrap">
                      <div class="col-lg-12" style="padding-top:50px;">
                        <mat-divider></mat-divider>
                      </div>
                    </div>
                    <div class="row wrap">
                      <div class="col-md-6 col-lg-6">
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="w-100">
                              <h3>Discounts</h3>
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100">
                              <mat-label>Algorithm</mat-label>
                              <mat-select [(value)]="form1.value.discountAlorithm" formControlName="discountAlorithm" pTooltip="Selects the algorithm applied to calculate discounts.">
                                @for (stat of discountAlorithms; track stat) {
                                  <mat-option [value]="stat.value"> {{stat.name}}
                                  </mat-option>
                                }
                              </mat-select>
                              @for (validation of validationMessages.discountAlorithm; track validation) {
                                <mat-error>
                                  @if (form1.get('discountAlorithm').hasError(validation.type) && (form1.get('discountAlorithm').dirty || form1.get('discountAlorithm').touched)) {
                                    <mat-error class="error-message"
                                      >
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6"></div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Days to Start Discounting: <b>{{discountLookForwardDays.value}} days</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('discountLookForwardDays', 1)">
                                  <i class="pi pi-minus"></i>
                                </button>
                                <mat-slider class="flex-1" min="0" max="365" step="1"
                                  pTooltip="Range: 0 to 365 as integer.  Determines how many days in advance of each available occupancy period to apply discounting algorithms.  A setting of 0 will apply NO discounts regardless of discount settings."
                                  tooltipPosition="bottom">
                                  <input matSliderThumb #discountLookForwardDays formControlName="discountLookForwardDays">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('discountLookForwardDays', 1)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Max Discount: <b>{{maxDiscountPCT.value*100}}%</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('maxDiscountPCT', 0.01)">
                                  <i class="pi pi-minus"></i>
                                </button>
                                <mat-slider class="flex-1" min="-1" max="1" step=".01"
                                  pTooltip="Range: -1 to +1 as decimal.  Determines the maximum discount to apply to the rack rate, but will not go lower than the the Min Nightly Rate $ setting below."
                                  tooltipPosition="bottom">
                                  <input matSliderThumb #maxDiscountPCT formControlName="maxDiscountPCT">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('maxDiscountPCT', 0.01)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Connecting Front <u>Or</u> Back Discount Multiplier: <b>{{connectingFrontOrBackMultiplierPCT.value*100}}%</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('connectingFrontOrBackMultiplierPCT', 0.01)">
                                  <i class="pi pi-minus"></i>
                                </button>
												<mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: -1 to +1 as decimal.  Negative value will increase discount for connecting either the front OR the back of an existing reservation,
									positive value will decrease the discount for connecting either the front OR the back of an existing reservation.
									Positive values may be used to discourage connecting reservations for housekeeping, deep cleans, owner requirements but will significantly reduce rent revenue." tooltipPosition="bottom">
                                  <input matSliderThumb #connectingFrontOrBackMultiplierPCT formControlName="connectingFrontOrBackMultiplierPCT">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('connectingFrontOrBackMultiplierPCT', 0.01)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Connecting Front <u>And</u> Back Discount Multiplier: <b>{{connectingFrontAndBackMultiplierPCT.value*100}}%</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('connectingFrontAndBackMultiplierPCT', 0.01)">
                                  <i class="pi pi-minus"></i>
                                </button>
												<mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: -1 to +1 as decimal.  Negative value will increase discount for connecting both the front AND the back of an existing reservation,
									positive value will decrease the discount for connecting both the front AND the back of an existing reservation.
									Positive values may be used to discourage connecting reservations for housekeeping, deep cleans, owner requirements but will significantly reduce rent revenue." tooltipPosition="bottom">
                                  <input matSliderThumb #connectingFrontAndBackMultiplierPCT formControlName="connectingFrontAndBackMultiplierPCT">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('connectingFrontAndBackMultiplierPCT', 0.01)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Short Gap Adjuster: <b>{{lengthOfStayDiscountFactorOffset.value*100}}%</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('lengthOfStayDiscountFactorOffset', 0.01)">
                                  <i class="pi pi-minus"></i>
                                </button>
												<mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: -1 to +1 as decimal. Negative value will increase discount, positive will decrease discount.
											EXAMPLE: There is a two night gap and our minNightsExpected is 3.
											A negative Short Gap Adjuster will reduce the price of the 2 night gap by xx% to incentivize a booking." tooltipPosition="bottom">
                                  <input matSliderThumb #lengthOfStayDiscountFactorOffset formControlName="lengthOfStayDiscountFactorOffset">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('lengthOfStayDiscountFactorOffset', 0.01)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6">
                        <div class="row wrap">
                          <div class="col-lg-12">
                            <div class="w-100">
                              <h3>Mark-Ups</h3>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Gaps - Stays Less Than Gap Nights Available: (shortTermGapMultiplierPCT)<b>{{shortTermGapMultiplierPCT.value*100}}%</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('shortTermGapMultiplierPCT', 0.01)">
                                  <i class="pi pi-minus"></i>
                                </button>
												<mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: 0-1 as decimal.  Applies a penalty if the number of nights available is less than the minNightsExpected.  EXAMPLE: minNightsExpected is 4, but only 3 nights are available in gap.  A setting of 0% means there will be no penalty to rate if they rent 1 out
									of the 3 nights.  A setting of 100% means there would be a 2 night penalty to rate if they rented 1 out of 3 nights" tooltipPosition="bottom">
                                  <input matSliderThumb #shortTermGapMultiplierPCT formControlName="shortTermGapMultiplierPCT">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('shortTermGapMultiplierPCT', 0.01)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Gaps - Stays Less Than Gap Nights Available <u>Penalty</u>: (shortTermGapPenaltyPCT)<b>{{shortTermGapPenaltyPCT.value*100}}%</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('shortTermGapPenaltyPCT', 0.01)">
                                  <i class="pi pi-minus"></i>
                                </button>
												<mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: 0-1 as decimal.  Determine how much of the Short Term Gap Occupancy Target penalty to apply.  EXAMPLE: A setting of 0% will apply NONE of the Short Term Gap Occupancy Target penalty, a setting of 100% will apply ALL of the Short Term Gap Occupancy Target penalty.
									If 2.8 nights desired but only 2 nights rented, a setting of xx% will apply only to the .8 night penalty." tooltipPosition="bottom">
                                  <input matSliderThumb #shortTermGapPenaltyPCT formControlName="shortTermGapPenaltyPCT">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('shortTermGapPenaltyPCT', 0.01)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Gaps - Charge Guest Min Number of Nights Revenue: (shortTermGapMinNumNightsRevNTS) <b>{{shortTermGapMinNumNightsRevNTS.value}} nights</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('shortTermGapMinNumNightsRevNTS', 0.25)">
                                  <i class="pi pi-minus"></i>
                                </button>
                                <mat-slider class="flex-1" min="0" max="10" step=".25"
                                  pTooltip="Range: 0-10 as integer.  Determines how many nights of revenue minimum to charge a guest if the avaialble nights is less than the minExpected nights.  EXAMPLE: Assume a 1 nights gap between two Christmas bookings.  A setting of 3 nights will allow the guest to book just the 1 night, but charge them for 3 even though it is a perfect back to back."
                                  tooltipPosition="bottom">
                                  <input matSliderThumb #shortTermGapMinNumNightsRevNTS formControlName="shortTermGapMinNumNightsRevNTS">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('shortTermGapMinNumNightsRevNTS', 0.25)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Stays Less Than minNights Expected: (longTermGapMultiplierPCT) <b>{{longTermGapMultiplierPCT.value*100}}%</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapMultiplierPCT', 0.01)">
                                  <i class="pi pi-minus"></i>
                                </button>
                                <mat-slider class="flex-1" min="-1" max="1" step=".01"
													pTooltip="Range: 0-1 as decimal.  EXAMPLE: A setting of 0% means there will be no additional penalty nights assessed if the minNightsExpected is 5 but the gust only books 3.
													Conversely, a setting of 100% would assess a 2 night penalty if the guest books 3 nights out 5 nights. (longTermGapMultiplierPCT)"
                                  tooltipPosition="bottom">
                                  <input matSliderThumb #longTermGapMultiplierPCT formControlName="longTermGapMultiplierPCT">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapMultiplierPCT', 0.01)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Stays Less Than minNights Expected <u>Penalty</u>: (longTermGapPenaltyPCT) <b>{{longTermGapPenaltyPCT.value*100}}%</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapPenaltyPCT', 0.01)">
                                  <i class="pi pi-minus"></i>
                                </button>
												<mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: 0-1 as decimal.
												Determines how much of the penalty nights to apply.  EXAMPLE: A setting of 0% will apply NONE of the pentaly nights, a setting of 100% will apply ALL of the penalty nights. (longTermGapPenaltyPCT)
									NOTE: If 12 nights desired but only 8 nights rented, a setting of xx% will be applied to the 4 nights." tooltipPosition="bottom">
                                  <input matSliderThumb #longTermGapPenaltyPCT formControlName="longTermGapPenaltyPCT">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapPenaltyPCT', 0.01)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Stays That Create Gaps On Either Side: (longTermGapEmptyMultiplierPCT) <b>{{longTermGapEmptyMultiplierPCT.value*100}}%</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapEmptyMultiplierPCT', 0.01)">
                                  <i class="pi pi-minus"></i>
                                </button>
												<mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: 0-1 as decimal.  EXAMPLE: A setting of 0% means there will be no penalty to rate if they rent 6 out
									of 12 nights with 3 night gaps on either side.  A setting of 100% means there would be a 6 night penalty to rate if they rented 6 out of 12 nights with 3 night gaps on either side" tooltipPosition="bottom">
                                  <input matSliderThumb #longTermGapEmptyMultiplierPCT formControlName="longTermGapEmptyMultiplierPCT">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapEmptyMultiplierPCT', 0.01)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Stays That Create Gaps On Either Side <u>Penalty</u>: (longTermGapEmptyPenaltyPCT) <b>{{longTermGapEmptyPenaltyPCT.value*100}}%</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapEmptyPenaltyPCT', 0.01)">
                                  <i class="pi pi-minus"></i>
                                </button>
                                <mat-slider class="flex-1" min="-1" max="1" step=".01"
                                  pTooltip="Range: 0-1 as decimal.  Determines how much of the Long Term Gap Occupancy Target penalty to apply.  EXAMPLE:  If 12 nights desired but only 8 nights rented, a setting of xx% will apply only to the 4 night penalty."
                                  tooltipPosition="bottom">
                                  <input matSliderThumb #longTermGapEmptyPenaltyPCT formControlName="longTermGapEmptyPenaltyPCT">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapEmptyPenaltyPCT', 0.01)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row wrap">
                      <div class="col-lg-12">
                        <mat-divider></mat-divider>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6 col-md-6">
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="w-100">
                              <h3>Marketing</h3>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <mat-form-field class="w-100">
                              <mat-label>Description</mat-label>
                              <input matInput formControlName="description" readonly="{{formReadOnly}}">
                              @for (validation of validationMessages.description; track validation) {
                                <mat-error>
                                  @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                                    <mat-error class="error-message">
                                      {{validation.message}}
                                    </mat-error>
                                  }
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-lg-12">
                            <mat-form-field class="w-100">
                              <mat-label>Public Description</mat-label>
                              <input matInput formControlName="publicRateDesc" readonly="{{formReadOnly}}">
                              @for (validation of validationMessages.publicRateDesc; track validation) {
                                <mat-error>
                                  @if (form1.get('publicRateDesc').hasError(validation.type) && (form1.get('publicRateDesc').dirty || form1.get('publicRateDesc').touched)) {
                                    <mat-error class="error-message"
                                      >
                                      {{validation.message}}
                                    </mat-error>
                                  }
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Headline Specials Look Forward Days: <b>{{discountLookForwardHeadlineDays.value}} days</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('discountLookForwardHeadlineDays', 1)">
                                  <i class="pi pi-minus"></i>
                                </button>
                                <mat-slider class="flex-1" min="0" max="180" step="1" pTooltip="" tooltipPosition="bottom">
                                  <input matSliderThumb #discountLookForwardHeadlineDays formControlName="discountLookForwardHeadlineDays">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('discountLookForwardHeadlineDays', 1)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="w-100">
                              <mat-label>Headline Specials Min Nights To Analyze: <b>{{discountLookForwardHeadlineMinNightsDays.value}} days</b></mat-label>
                              <div>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('discountLookForwardHeadlineMinNightsDays', 0.01)">
                                  <i class="pi pi-minus"></i>
                                </button>
                                <mat-slider class="flex-1" min="0" max="10" step=".01" pTooltip=""
                                  tooltipPosition="bottom">
                                  <input matSliderThumb #discountLookForwardHeadlineMinNightsDays formControlName="discountLookForwardHeadlineMinNightsDays">
                                </mat-slider>
                                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('discountLookForwardHeadlineMinNightsDays', 0.01)">
                                  <i class="pi pi-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="col-lg-12">
                          <div class="w-100">
                            <mat-label>Discount Interval Days: <b>{{discountIntervalDays.value}} days</b></mat-label>
                            <div>
												<mat-slider class="flex-1" #discountIntervalDays formControlName="discountIntervalDays" min="0" max="30" step=".01" pTooltip="Range: 0+ as integer. Documents how many nights to
									group together as one price for advertising" tooltipPosition="bottom">
                              </mat-slider>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div class="w-100">
                            <mat-label>Discount Combination Days: <b>{{discountCombinationDays.value}} days</b></mat-label>
                            <div>
                              <mat-slider class="flex-1" #discountCombinationDays formControlName="discountCombinationDays" min="0" max="30" step=".01"
                                pTooltip="Range: 0+ as integer. Documents minimum number of consecutive nights the rate engine should process in a row so it does not just break before a new season rate start."
                                tooltipPosition="bottom">
                              </mat-slider>
                            </div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="row wrap">
                    <div class="col-lg-6">
                    </div>
                    <div class="col-lg-12">
                      <mat-divider></mat-divider>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
            <!-- <mat-tab *ngIf="rateSeasonId" label="History">
            <app-change-history-list [localId]="rateSeasonId" [typeName]="'com.yieldmax.multi.rateSeason.RateSeasonVO'"></app-change-history-list>
          </mat-tab> -->
          @if (rateSeasonId) {
            <mat-tab label="History">
              @if (rateSeasonId) {
                <app-audit-list [source]="'YM'" [auditUrl]="'rateSeasons/' + rateSeasonId + '/audit'"></app-audit-list>
              }
            </mat-tab>
          }
        </mat-tab-group>
      </mat-dialog-content>




      <mat-dialog-actions>
        <div class="row m-0">
          <div class="col-lg-12">
            <div class="btn-group">
              <div class="button-group">
                @if (rateSeasonId) {
                  <button pButton class="btn-delete p-button-outlined p-button-danger" (click)="onFormDelete()" [disabled]="formLoading">Delete</button>
                }
              </div>

              <div class="button-group">
                <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true" [disabled]="formLoading">Cancel</button>
                @if (!rateSeasonId) {
                  <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
                }

                @if (rateSeasonId) {
                  <button pButton class="btn-upt p-button" (click)="formUpdate()" [disabled]="formLoading">
                    @if (formLoading) {
                      <i class="pi pi-spin pi-spinner" style="margin-right:5px;"></i>Saving...
                    } @else {
                      Update
                    }
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </mat-dialog-actions>

    </div>